import { jsonrepair } from "jsonrepair";

export function parseJson5(input: unknown): unknown {
  if (typeof input === "string") {
    // Return empty string as-is to avoid parseJSON error
    if (input.trim() === "") {
      return input;
    }

    // Parse incomplete JSON
    try {
      return JSON.parse(jsonrepair(input));
    } catch {
      // Return the original string
      return input;
    }
  }
  return input;
}
